import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stores--discord-config"
export default class extends Controller {
  static targets = ["status", "categorySelect"]

  /**
   * Teste la connexion Discord
   */
  async testConnection() {
    try {
      this.updateStatus("testing", "Test de connexion en cours...")
      
      const storeId = this.element.dataset.storeId || window.location.pathname.match(/stores\/(\d+)/)[1]
      const response = await fetch(`/admin/stores/${storeId}/test_discord_connection`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      const result = await response.json()
      
      if (result.success) {
        this.updateStatus("success", result.message)
        // Recharger la page pour mettre à jour les catégories
        setTimeout(() => window.location.reload(), 1000)
      } else {
        this.updateStatus("error", result.message)
      }
    } catch (error) {
      console.error('Discord connection test failed:', error)
      this.updateStatus("error", "Erreur lors du test de connexion")
    }
  }

  /**
   * Crée une catégorie d'archivage
   */
  async createArchiveCategory() {
    try {
      this.updateStatus("testing", "Création de la catégorie d'archivage...")
      
      const storeId = this.element.dataset.storeId || window.location.pathname.match(/stores\/(\d+)/)[1]
      const response = await fetch(`/admin/stores/${storeId}/create_archive_category`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      const result = await response.json()
      
      if (result.success) {
        this.updateStatus("success", "Catégorie d'archivage créée avec succès")
        
        // Mettre à jour le sélecteur si présent
        if (this.hasCategorySelectTarget) {
          // Ajouter la nouvelle option
          const option = document.createElement('option')
          option.value = result.category_id
          option.textContent = result.category_name
          option.selected = true
          this.categorySelectTarget.appendChild(option)
        }
        
        // Recharger la page pour mettre à jour l'interface
        setTimeout(() => window.location.reload(), 1000)
      } else {
        this.updateStatus("error", result.message)
      }
    } catch (error) {
      console.error('Archive category creation failed:', error)
      this.updateStatus("error", "Erreur lors de la création de la catégorie")
    }
  }

  /**
   * Met à jour l'affichage du statut
   * @param {string} status - success, error, warning, testing
   * @param {string} message - Message à afficher
   */
  updateStatus(status, message) {
    if (!this.hasStatusTarget) return

    const iconClasses = {
      success: "fa-solid fa-circle-check text-green-600",
      error: "fa-solid fa-circle-xmark text-red-600", 
      warning: "fa-solid fa-triangle-exclamation text-yellow-600",
      testing: "fa-solid fa-spinner fa-spin text-blue-600"
    }

    const textClasses = {
      success: "text-green-600",
      error: "text-red-600",
      warning: "text-yellow-600", 
      testing: "text-blue-600"
    }

    // Mettre à jour l'icône
    const icon = this.statusTarget.querySelector('i')
    if (icon) {
      icon.className = iconClasses[status] || iconClasses.warning
    }

    // Mettre à jour le texte
    const text = this.statusTarget.querySelector('.status-message')
    if (text) {
      text.className = `text-sm ${textClasses[status] || textClasses.warning}`
      text.textContent = message
    }
  }

  /**
   * Gère le changement de sélection de catégorie
   */
  categoryChanged() {
    if (!this.hasCategorySelectTarget) return
    
    const selectedValue = this.categorySelectTarget.value
    
    // Optionnel: sauvegarder automatiquement
    // this.autoSave()
  }

  /**
   * Sauvegarde automatique (optionnel)
   */
  async autoSave() {
    // Implémentation de la sauvegarde automatique si nécessaire
  }
}